import styled from 'styled-components';
import { unitizedPx } from '@badi/badi-components';

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: ${unitizedPx(1)};
  max-width: 460px;
`;
